import { get } from 'axios'
import {
  select,
  fork,
  takeEvery,
  call,
  put,
} from 'redux-saga/effects'

import { baseURL } from 'config'
import {
  formatImageBase64,
} from 'helpers/actionHelper'
import {
  FETCH_EMPLOYEE_IMAGE,
} from './constants'
import {
  startFetchEmployeeImageAsync,
  updateEmployeeImage,
  fetchEmployeeImageStart,
  fetchEmployeeImageSuccess,
  fetchEmployeeImageError,
} from './actions'

const url = `${baseURL}/api/cftt_external/GetUserPhoto`
const urlParams = '?netlogonId='
const buildUrl = (username) => `${url}${urlParams}${username}`

function* getEmployeeImage(username) {
  try {
    yield put(startFetchEmployeeImageAsync())
    yield put(fetchEmployeeImageStart())

    const requestUrl = buildUrl(username)
    const { data } = yield call(get, requestUrl)
    const image = formatImageBase64(data)

    yield put(fetchEmployeeImageSuccess())
    return {
      [username]: {
        username,
        image
      }
    }
  } catch(error) {
    yield put(fetchEmployeeImageError(error))
  }
}

function* fetchEmployeeImageHandler(action) {
  const { username } = action
  const data = yield call(getEmployeeImage, username)
  yield put(updateEmployeeImage(data))
}

function* watchFetchEmployeeImage () {
  yield takeEvery(FETCH_EMPLOYEE_IMAGE, fetchEmployeeImageHandler)
}

export default watchFetchEmployeeImage
